import { ConsentState } from "./cookieTypes";

export const STORAGE_KEY = 'cookie_consent';

export const saveConsent = (consent: ConsentState): void => {
	localStorage.setItem(STORAGE_KEY, JSON.stringify({
		consent,
		timestamp: new Date().toISOString()
	}));
};

export const loadConsent = (): ConsentState | null => {
	const EXPIRATION_MS = 10 * 24 * 60 * 60 * 1000 // 10 days

	const stored = localStorage.getItem(STORAGE_KEY);
	if (!stored) return null;
	try {
		const { consent, timestamp } = JSON.parse(stored);
		if (Date.now() - new Date(timestamp).getTime() > EXPIRATION_MS) return null;
		return consent;
	} catch {
		return null;
	}
};